<template>
    <Uploader></Uploader>
</template>

<script>
    import { defineAsyncComponent } from "vue";

    const AuthLayout = defineAsyncComponent(() =>
        import("../../Layouts/AuthLayout.vue")
    );
    const Uploader = defineAsyncComponent(() =>
        import("../../components/Design/Uploader.vue")
    );

    export default {
        name: "UploaderPage", //The name you are in should not equal the name of the component you are importing.
        components: { Uploader, AuthLayout },
    };
</script>
